export const gitCommit = '71e5372c'
